import * as Sentry from "@sentry/react";

/**
 * Sentry DSN — a public ingest key, safe to ship in the bundle. Hardcoded
 * so it survives CI rebuilds; `VITE_SENTRY_DSN` can override it. Errors +
 * traces flow to the `vihangam-yog-admin-production` project.
 */
const DSN =
  import.meta.env.VITE_SENTRY_DSN ||
  "https://01c3a3cdc63d2e3d07d8c192cb6f3e5e@o4507009979645952.ingest.us.sentry.io/4511732910260224";

/** The VY backend Worker — spans that call it continue the same trace. */
const BACKEND_ORIGIN = /vy-australia-backend\.kishek12\.workers\.dev/;

export function initSentry(): void {
  if (!DSN) {
    return;
  }
  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", BACKEND_ORIGIN],
    sendDefaultPii: false,
  });

  // Visit any page with `?debug-sentry` to fire a captured test event.
  if (new URLSearchParams(window.location.search).has("debug-sentry")) {
    Sentry.captureException(new Error("VY admin Sentry test error"));
  }
}
